import { HttpClient } from "@angular/common/http";
import { constantvalues } from "../../const";
import { Injectable } from "@angular/core";
import { environment } from '../environments/environment.development'

@Injectable({
    providedIn: 'root'
})

export class ErrorLogService{
    baseURL: string;
    constructor(private httpClient: HttpClient) {
        this.baseURL = environment.gatewayUrl; 
    }

    getErrorLogs(payload: any){
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.GET_ERROR_LOGS}`, {params: payload});
    }
    
    getTraceLogs(payload: any){
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.GET_TRACE_LOGS}`, {params: payload});
    }
}